export const highlightSearchedText = (text: string, search?: string, flags?: string) =>
  search && text
    ? text.replace(new RegExp(search, flags), `<strong>$&</strong>`) // Symbols $& - Inserts the matched substring
    : text;
